import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ResultData } from 'src/app/_models/ResultData';
import { LevelService } from 'src/app/_services/level.service';

@Component({
  selector: 'app-country-level-syllabus',
  templateUrl: './country-level-syllabus.component.html',
  styleUrls: ['./country-level-syllabus.component.css']
})
export class CountryLevelSyllabusComponent implements OnInit {

  countries=[]
  loading=true
  constructor(private levelService:LevelService,private router:Router) { }

  ngOnInit(): void {

    this.levelService.levelsForCountryFlatten().subscribe(
      {next:(data:ResultData)=>{
        this.countries=data.rs.data.countries
        this.loading=false
      },error:(err)=>{
        console.error("Error retrieving countries",err)
      }

      }
    )

  }
  navToFreePdf(){
    this.router.navigate(['/free-pdf'])

  }
}
